/**
 * TFACT 利用マニュアルの URL を組み立てる。
 *
 * マニュアルのホストは環境ごとに異なる（dev は dev.sstf.agest.app）ため、
 * URL 全体をベタ書きせず「ベース URL（env で差し替え）＋ ページのパス（定数）」に分ける。
 * ベース URL はビルド時に焼き込まれるため、docker build の
 * REACT_APP_TFACT_MANUAL_BASE_URL に環境ごとの値を渡すこと。
 */
const DEFAULT_MANUAL_BASE_URL = "https://sstf.agest.app/docs/tfact/manual";

/** マニュアルのベース URL（末尾スラッシュなしに正規化して返す）。 */
export function getManualBaseUrl(
  baseUrl: string | undefined = process.env.REACT_APP_TFACT_MANUAL_BASE_URL,
): string {
  return (baseUrl || DEFAULT_MANUAL_BASE_URL).replace(/\/+$/, "");
}

/**
 * マニュアル内ページのパス。
 *
 * マニュアルは GCS へ静的配信されており拡張子なしの URL は 404 になるため、
 * ページのパスには必ず `.html` を付ける。
 */
export const MANUAL_PATHS = {
  /** 結果確認ツール > メイン画面 */
  resultCheckerMain: "/ja/reference/result-checker/01-main.html",
} as const;

/** マニュアルルートからの絶対パス（先頭 `/`）を完全な URL にする。 */
export function buildManualUrl(path: string, baseUrl?: string): string {
  return `${getManualBaseUrl(baseUrl)}${path}`;
}
